import {useCallback} from 'react';

import {clearMismatchValidationErrorsInNote} from 'notebook/tables/excess/clearMismatchValidationErrors';
import {TableNoteContext} from 'notebook/tables/store/contexts/TableNoteContext';

/**
 * Hook for note-level actions that operate through the TableNoteContext.
 *
 * Unlike useTableActions (which also requires HydratedTableContext), this hook only
 * depends on TableNoteContext and can be used from any component inside a NoteEditor.
 */
export function useNoteActions(): {
  clearMismatchValidationErrors: (
    tableName?: string,
    cellId?: {columnProvenanceUuid: string; rowId: string}
  ) => void;
} {
  const {fileId, getNote, updateNote} = TableNoteContext.useContext();

  const clearMismatchValidationErrors = useCallback(
    (tableName?: string, cellId?: {columnProvenanceUuid: string; rowId: string}) => {
      const note = getNote();
      const updated = clearMismatchValidationErrorsInNote(note, tableName, cellId);
      if (updated !== note) {
        updateNote(updated, {multidocTableOp: {[fileId]: 'noop'}});
      }
    },
    [fileId, getNote, updateNote]
  );

  return {clearMismatchValidationErrors};
}
